import { lazy } from 'react';
import * as routePath from '../route-path';
import * as routeName from '../route-name';
import { StoreIcon } from 'components/Atoms/Icon';
import { USER_LEVEL_TYPE } from 'constants/common';

const StoreTemplate = lazy(() => import('components/Pages/StoreTemplate'));

const TemplateDetail = lazy(() => import('components/Pages/TemplateDetail'));

export const templateRoutes = [
  {
    path: routePath.STORE_TEMPLATE,
    component: StoreTemplate,
    exact: true,
    showMenu: true,
    icon: StoreIcon,
    name: routeName.STORE_TEMPLATE,
    breadcrumbs: [],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
  {
    path: routePath.STORE_TEMPLATE_DETAIL,
    component: TemplateDetail,
    exact: true,
    parentName: routeName.STORE_TEMPLATE,
    breadcrumbs: [],
    roles: [USER_LEVEL_TYPE.ADMIN, USER_LEVEL_TYPE.CAMPAIGN_MANAGER],
  },
];
